import { useCallback } from 'react';
import { connect } from 'react-redux';
import { closeAppSidebar, redirectInModal } from './actions';
import StyledSidebarLink from './StyledSidebarLink';

const SidebarModalNavigatedLink = ({ redirect, closeSidebar, href, onClick, target, ...other }: $TSFixMe) => {
    const handleClick = useCallback(
        (e: React.MouseEvent) => {
            e.preventDefault();
            redirect(href);

            if (onClick) {
                onClick(e);
            }

            closeSidebar();
        },
        [closeSidebar, onClick, href, redirect]
    );

    return <StyledSidebarLink href={href} target={target} onClick={handleClick} {...other} />;
};

export default connect(undefined, {
    closeSidebar: closeAppSidebar,
    redirect: redirectInModal,
})(SidebarModalNavigatedLink);
